import FieldCurrencyPaypal from './FieldCurrencyPaypal';
export default FieldCurrencyPaypal;
